/**
 * Names Stripe's Connect SDK registers its Capital embedded components under. They must match the
 * component keys enabled on the Account Session in
 * `servers/payments/.../stripe-gateway-adapter.ts#createCapitalAccountSession`.
 */
export const CAPITAL_FINANCING_PROMOTION_COMPONENT = 'capital-financing-promotion'
export const CAPITAL_FINANCING_COMPONENT = 'capital-financing'

/** Gateway type the Capital components require — Connect embedded components are Stripe-only. */
export const STRIPE_GATEWAY_TYPE = 'stripe'
